import React, { Component } from 'react';
import axios from 'axios';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from 'react-router-dom';
import { findIndex, sortBy, find } from 'lodash';
// material
import { Container, Grid } from '@material-ui/core';
// app
import { updateSession, setApiUrls, addAuth, openSnackbar, closeSnackbar } from '../../../store/action-creators';
// containers
import AdminContainer from '../../../containers/Admin';
// models
import { Auth, Session } from '../../../entities/auth';
import { APIUrl, CampaignContact } from '../../../entities/site';
// components
import Loading from '../../../components/site/Loading';
import ActionButton from '../../../components/buttons/ActionButton';
import AddCampaign from '../../../components/campaign/AddCampaign';
import DropContacts from '../../../components/campaign/DropContacts';
import AddCampaignTimeline from '../../../components/campaign/AddCampaignTimeline';
import AddCollaborator from '../../../components/campaign/details/AddCollaborator';
import AddCampaignMessage from '../../../components/campaign/AddCampaignMessage';
import CampaignContactHeaders, { MappedHeader } from '../../../components/campaign/CampaignContactHeaders';
import { SelectItem } from '../../../components/inputs/SelectInput';
import CampaignContactsList from '../../../components/campaign/CampaignContactsList';
// entities
import { TeamUser, Collaborator, TeamList } from '../../../entities/site';
import { MessageTemplate } from '../../../entities/notification';
import { User } from '../../../entities/user';
// services
import CampaignService from '../../../services/campaign';
import AuthService from '../../../services/auth';

const daysMap = ['Sun', 'Mon', 'Tue', 'Wed', 'Thurs', 'Fri', 'Sat']

const styles: any = {
  tableWrapper: {
    maxHeight: 440,
    overflow: 'auto',
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    paddingTop: 10,
    paddingBottom: 10,
    textAlign: 'left'
  },
  template: {
    marginTop: 10
  }
}

interface AdminPageProps {
  history: any;
  auth: Auth;
  session: Session;
  apiUrls: APIUrl;
  updateSession(session: Session): void;
  setApiUrls(urls: APIUrl): void;
  openSnackbar(message: string): void;
  closeSnackbar(): void;
}

interface AdminPageState {
  loading: boolean;
  totalContacts: number;
  contactChunks: [];
  contactErrors: CampaignContact[];

  teamUsers: TeamUser[];
  branches: TeamList[];
  openAddCollaborators: boolean;
  collaborators: Collaborator[];

  campaignName: string;
  campaignType: string;
  campaignClient: string;
  templates: MessageTemplate[];
  template: string;
  templatesList: SelectItem[];
  selectedTemplate: string;
  messagesPerDay: number;
  daysOfWeek: number[];
  startDate: string;
  endDate: string;
  redirectUrl: string;
  contactName: string;
  showContactList: boolean;
  campaignContacts: CampaignContact[],
  contactListTitle: string;
  contactListType: string;
  fileData: any;
  headers: string[];
  uploadHeaders: SelectItem[];
  mappedHeaders: MappedHeader[];
  showMappedHeaders: boolean;
}

// const [teamsUsers, setTeamsUsers] = useState<TeamUser[]>([]);
// const [branches, setBranches] = useState<TeamList[]>([]);

class AdminPage extends Component<AdminPageProps, AdminPageState> {

  constructor(props: AdminPageProps) {
    super(props);
    this.state = {
      loading: false,
      totalContacts: 0,
      contactChunks: [],
      contactErrors: [],

      teamUsers: [],
      branches: [],
      openAddCollaborators: false,
      collaborators: [],

      campaignName: '',
      campaignType: '',
      campaignClient: 'homewize',
      templates: [],
      template: '',
      templatesList: [],
      selectedTemplate: '',
      messagesPerDay: 100,
      daysOfWeek: [],
      startDate: '',
      endDate: '',
      redirectUrl: '',
      contactName: '',
      showContactList: false,
      campaignContacts: [],
      contactListTitle: '',
      contactListType: 'contacts',
      fileData: null,
      headers: [],
      uploadHeaders: [],
      mappedHeaders: [],
      showMappedHeaders: false
    }
  }

  componentDidMount = async () => {

    this.fetchTeamUsers();
    this.fetchTemplates();

  }

  handleSearchUsers = (users: User[]) => {
    const teamsUserList: TeamUser[] = [];

    users.forEach((user: User) => {
      teamsUserList.push({
        id: user.userId,
        userId: user.userId,
        email: user.email,
        name: user.name,
        teamId: 'null',
        teamName: 'null',
        teamType: 'null',
        createdDate: user.createdDate
      })
    });

    if (users.length > 0) {
      this.setState({
        teamUsers: teamsUserList
      });
    } else {
      this.fetchTeamUsers();
    }

  }

  fetchTeamUsers = async () => {

    const teamsUserList: TeamUser[] = [];
    const branchesList: TeamList[] = [];

    const teamUsersRes = await axios.get(`${AuthService.getApiUrls().site}/team/users/${this.props.auth.id}`);

    if (teamUsersRes) {

      teamsUserList.push({
        id: this.props.auth.id,
        userId: this.props.auth.id,
        email: (this.props.auth.user ? this.props.auth.user.email : ''),
        name: (this.props.auth.user ? this.props.auth.user.name : ''),
        teamId: 'null',
        teamName: 'null',
        teamType: 'null',
        createdDate: 0
      });

      teamUsersRes.data.forEach((teamUser: TeamUser) => {
        const teamUserIndex = findIndex(teamsUserList, {
          userId: teamUser.userId,
        });
        if (teamUserIndex === -1) {
          teamUser.id = teamUser.userId;
          teamsUserList.push(teamUser);
        }
        if (teamUser.teamType === "branch") {
          const branchIndex = findIndex(branchesList, { teamId: teamUser.teamId });
          if (branchIndex === -1) {
            branchesList.push({
              teamId: teamUser.teamId,
              teamName: teamUser.teamName,
              teamType: teamUser.teamType,
            });
          }
        }

      });

      this.setState({
        teamUsers: teamsUserList,
        branches: branchesList
      });

    }
  };

  fetchTemplates = async () => {

    const templateRes = await axios.get(`${AuthService.getApiUrls().notifications}/message/templates`);
    let templates = templateRes.data;
    templates = sortBy(templates, 'createdDate').reverse();
    const list: SelectItem[] = [];
    templates.forEach((template: MessageTemplate) => {
      if (template.type === 'campaign') {
        list.push({
          name: template.name,
          value: template.id
        });
      }
    });
    this.setState({ templates: templateRes.data, templatesList: list });

  }

  handleShowLoading = () => {
    this.setState({ loading: true });
  }

  handleRoute = (campaignId: string) => {
    this.props.history.push(`/admin/campaign/${campaignId}`);
  }

  handleFileDrop = async (data: any) => {

    try {

      // get headers
      const parseHeaderRes = await axios.post(`${AuthService.getApiUrls().site}/campaign/contacts/parse/headers`, { file: data });

      if (parseHeaderRes.data.errorMessage) {
        throw parseHeaderRes.data.errorMessage;
      }
      const headersArray = parseHeaderRes.data;
      const headerItems: SelectItem[] = [
        {
          name: 'Empty Column',
          value: 'empty'
        }
      ];
      headersArray.forEach((header: string) => {
        headerItems.push({
          name: header,
          value: header
        })
      });

      this.setState({
        fileData: data,
        headers: headersArray,
        uploadHeaders: headerItems,
        showMappedHeaders: true
      });

    } catch (error) {
      console.log('error', error);
    }

  }

  handleHeaderClose = async (mapped: MappedHeader[]) => {

    this.setState({ showMappedHeaders: false });

    if (!mapped.length) {
      // show error
      return;
    }

    const mappedNew: MappedHeader[] = [];
    CampaignService.getSupportedColumns().forEach((supportedColumn: string) => {

      const search = find(mapped, { supportedColumn })
      if (search) {
        search.index = this.state.headers.indexOf(search.column);
        mappedNew.push(search);
      } else {
        mappedNew.push({
          supportedColumn,
          column: '',
          index: -1
        });
      }
    });

    this.setState({ mappedHeaders: mappedNew });

    // parse again with mapped columns
    const fileDataBody = {
      file: this.state.fileData,
      cols: mappedNew
    };
    const parseRes = await axios.post(`${AuthService.getApiUrls().site}/campaign/contacts/parse`, fileDataBody);
    if (parseRes.data) {
      this.setState({
        totalContacts: parseRes.data.rows,
        contactChunks: parseRes.data.chunks,
        contactErrors: parseRes.data.errors
      });
    }

  }

  handleContactsClick = (type: string) => {
    let contactList: CampaignContact[] = [];
    let contactListTitle = 'Valid Contacts';
    if (type === 'contacts') {
      // loop through the chunks
      this.state.contactChunks.forEach((chunk: CampaignContact[]) => {
        chunk.forEach((contact: CampaignContact) => {
          contactList.push(contact);
        });
      })
    } else {
      contactListTitle = 'Contacts Missing Required Data';
      contactList = this.state.contactErrors;
    }
    this.setState({
      contactListTitle,
      contactListType: type,
      showContactList: true,
      campaignContacts: contactList
    });
  }

  handleCampaignContactListClose = () => {
    this.setState({
      showContactList: false
    });
  }

  handleSaveCampaign = async () => {

    try {

      this.setState({ loading: true });

      // build daysOfWeek string
      let daysOfWeekStr = '';
      this.state.daysOfWeek.forEach((day) => {
        daysOfWeekStr += `${daysMap[day]},`;
      });
      daysOfWeekStr = daysOfWeekStr.substring(0, daysOfWeekStr.length - 1);

      // save campaign
      const campaignData = {
        name: this.state.campaignName,
        type: this.state.campaignType,
        client: this.state.campaignClient,
        status: 'new',
        templateId: this.state.selectedTemplate,
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        daysOfWeek: daysOfWeekStr,
        messagesPerDay: this.state.messagesPerDay,
        totalContacts: this.state.totalContacts,
        redirectUrl: (this.state.redirectUrl ? this.state.redirectUrl : 'null'),
        contactName: this.state.contactName
      };
      const campaignRes = await axios.post(`${AuthService.getApiUrls().site}/campaign`, campaignData);

      const campaignId = campaignRes.data.id;
      const campaignName = this.state.campaignName;

      // save campaign contacts
      const contactData = {
        campaignId,
        campaignName,
        chucks: this.state.contactChunks
      };

      await axios.post(`${AuthService.getApiUrls().site}/campaign/contacts/import`, contactData);

      // save campaign collaborators
      const collaboratorData = {
        campaignId,
        campaignName: this.state.campaignName,
        collaborators: this.state.collaborators
      };
      await axios.post(`${AuthService.getApiUrls().site}/campaign/collaborators/import`, collaboratorData);

      this.handleRoute(campaignId);

      this.setState({ loading: false });

    } catch (error) {
      // show error message
      this.setState({ loading: false });
    }
    
  }

  handleCampaignChange = (name: string, value: string) => {
    if (name === 'name') {
      this.setState({ campaignName: value });
    }
    if (name === 'type') {
      this.setState({ campaignType: value });
    }
    if (name === 'client') {
      this.setState({ campaignClient: value });
    }
    if (name === 'redirectUrl') {
      this.setState({ redirectUrl: value });
    }
    if (name === 'contactName') {
      this.setState({ contactName: value });
    }
    if (name === 'template') {
      this.setState({
        selectedTemplate: value,
        loading: true
      });
      axios.get(`${AuthService.getApiUrls().notifications}/message/template/${value}`).then((res) => {
        this.setState({
          template: res.data.description,
          loading: false
        });
      }).catch(() => {
        this.setState({ loading: false });
      });

    }
  }

  handleTimelineChange = (type: string, valueStr: string) => {
    // this is shit code
    if (type === 'messagesPerDay') {
      const messages = valueStr ? parseInt(valueStr, 10) : 0;
      this.setState({ messagesPerDay: messages });
    }
    if (type === 'startDate') {
      this.setState({ startDate: valueStr });
    }
    if (type === 'endDate') {
      this.setState({ endDate: valueStr });
    }
  }

  handleWeekDayChange = (value: number) => {
    const daysOfWeek = [...this.state.daysOfWeek];
    const index = this.state.daysOfWeek.indexOf(value);
    if (index > -1) {
      daysOfWeek.splice(index, 1);
    } else {
      daysOfWeek.push(value);
    }
    this.setState({ daysOfWeek });
  }

  handleCollaboratorOpen = (open: boolean) => {
    this.setState({ openAddCollaborators: open });
  }

  handleCollaboratorChange = (checked: boolean, collaborator: Collaborator) => {
    let newCollaborators = [...this.state.collaborators];
    if (checked) {
      newCollaborators.push(collaborator);
    } else {
      newCollaborators = newCollaborators.filter((c) => c.id !== collaborator.id);
    }

    console.log('newCollaborators', newCollaborators);
    console.log('collaborator', collaborator);

    this.setState({ collaborators: newCollaborators });
  }

  handleCollaboratorNotifyChange = (checked: boolean, collaborator: Collaborator) => {

    const updateCollaborators = [...this.state.collaborators];
    const collaboratorIndex = findIndex(updateCollaborators, { userId: collaborator.userId });
    // updateCollaborators.find(c => c.userId === collaborator.userId)?.notify = checked;
    if (collaboratorIndex !== -1) {
      updateCollaborators[collaboratorIndex].notify = checked;
      this.setState({ collaborators: updateCollaborators });
    }

  };

  handleDeleteCollaborator = (id: string) => {
    let newCollaborators = [...this.state.collaborators];
    newCollaborators = newCollaborators.filter((c) => c.id !== id);
    this.setState({ collaborators: newCollaborators });
  };

  render() {

    return (
      <AdminContainer showOption={false} private={false} maxWidth={false}>
        <Loading open={this.state.loading} />
        <Container maxWidth="lg">
          <Grid container spacing={8}>
            <Grid item xs={6}>
              <div style={styles.title}>Campaign Details</div>
              <AddCampaign
                name={this.state.campaignName}
                type={this.state.campaignType}
                client={this.state.campaignClient}
                showClients
                onChange={this.handleCampaignChange}
              />
            </Grid>
            <Grid item xs={6}>
              <DropContacts
                onDrop={this.handleFileDrop}
                onClick={this.handleContactsClick}
                total={this.state.totalContacts}
                errors={this.state.contactErrors.length}
              />
              <CampaignContactsList
                open={this.state.showContactList}
                title={this.state.contactListTitle}
                campaignContacts={this.state.campaignContacts}
                onClose={this.handleCampaignContactListClose}
              />
            </Grid>
          </Grid>

          <Grid container spacing={8}>
            <Grid item xs={6}>
              <AddCollaborator
                teamsUsers={this.state.teamUsers}
                branches={this.state.branches}
                open={this.state.openAddCollaborators}
                collaborators={this.state.collaborators}
                showSearch
                onSearch={this.handleSearchUsers}
                onClose={() => this.handleCollaboratorOpen(false)}
                onOpen={() => this.handleCollaboratorOpen(true)}
                onChange={this.handleCollaboratorChange}
                onNotifyChange={this.handleCollaboratorNotifyChange}
                onDelete={this.handleDeleteCollaborator}
              />
            </Grid>
            <Grid item xs={6}>
              <div style={styles.subTitle}>Message</div>
              <AddCampaignMessage
                templates={this.state.templatesList}
                selected={this.state.selectedTemplate}
                message={this.state.template}
                redirectUrl={this.state.redirectUrl}
                contactName={this.state.contactName}
                onChange={this.handleCampaignChange}
              />
            </Grid>
          </Grid>

          <Grid container spacing={8}>
            <Grid item xs={6}>
              <div style={styles.subTitle}>Select Timeline</div>
              <AddCampaignTimeline
                messagesPerDay={this.state.messagesPerDay}
                weekDays={this.state.daysOfWeek}
                startDate={this.state.startDate}
                endDate={this.state.endDate}
                onChange={this.handleTimelineChange}
                onWeekDayChange={this.handleWeekDayChange}
              />
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            justify="flex-end"
            alignItems="center"
          >
            <Grid item xs={4}>
              <ActionButton name="Save Campaign" size="sm" onClick={this.handleSaveCampaign} fullWidth />
            </Grid>
          </Grid>
        </Container>
        <CampaignContactHeaders
          open={this.state.showMappedHeaders}
          headers={this.state.uploadHeaders}
          onClose={this.handleHeaderClose}
        />
      </AdminContainer>
    )
  }


}

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth.auth,
    session: state.session.session,
    apiUrls: state.site.apiUrls
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({ updateSession, setApiUrls, addAuth, openSnackbar, closeSnackbar }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter<any, any>(AdminPage));



// WEBPACK FOOTER //
// ./src/pages/admin/campaign/AdminCampaignCreate.tsx